var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuickScan = function SvgQuickScan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#003671",
    strokeLinecap: "round",
    d: "M6.667 1H2.889A1.889 1.889 0 0 0 1 2.889v3.778M6.667 18H2.889A1.889 1.889 0 0 1 1 16.111v-3.778M12.333 1h3.778A1.89 1.89 0 0 1 18 2.889v3.778m0 5.666v3.778A1.889 1.889 0 0 1 16.111 18h-3.778m-4.958-5.313h4.25c.587 0 1.063-.475 1.063-1.062v-4.25c0-.587-.476-1.063-1.063-1.063h-4.25c-.587 0-1.063.476-1.063 1.063v4.25c0 .587.476 1.063 1.063 1.063Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgQuickScan as ReactComponent };
export default __webpack_public_path__ + "521ead8f615f83e83b4f14c3f7717f98.svg";